import * as FormFields from "../../../src/Components/FormFields/FormFields.scss";
import { Record, Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { tuple_type, option_type, record_type, list_type, bool_type, union_type, lambda_type, unit_type, class_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { map, cons, ofArrayWithTail, append, ofArray, empty } from "../../fable_modules/fable-library.3.7.20/List.js";
import * as react from "react";
import { logi, stackClasses, Locale_get_defaultLocale, Locale$reflection, classNames } from "../../Utils.js";
import { comparePrimitives, max, equals } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { empty as empty_1, singleton, append as append_1, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { CSSProp, DOMAttr, HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { value as value_3, some } from "../../fable_modules/fable-library.3.7.20/Option.js";
import * as light from "flatpickr/dist/themes/light.css";
import { Value as Value_1, TimeTwentyFour as TimeTwentyFour_1, OnChange as OnChange_1, EnableBy as EnableBy_1, Locale, FormatDateBy as FormatDateBy_1, Id as Id_1, flatpickr, ClassName, Disabled as Disabled_1 } from "../../fable_modules/Fable.React.Flatpickr.3.0.0/Flatpickr.fs.js";
import { getWrappedMaterialIcon } from "../../ViewUtils.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";


export class ValueProp extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ValueOnChange", "ReactDefaultValue", "Nothing"];
    }
}

export function ValueProp$reflection() {
    return union_type("Components.FormFields.ValueProp", [], ValueProp, () => [[["Item1", string_type], ["Item2", lambda_type(class_type("Browser.Types.Event", void 0, Event), unit_type)]], [["Item", string_type]], []]);
}

export class Validation$1 extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["NoValidation", "ValidationFunc"];
    }
}

export function Validation$1$reflection(gen0) {
    return union_type("Components.FormFields.Validation`1", [gen0], Validation$1, () => [[], [["Item", lambda_type(string_type, union_type("Microsoft.FSharp.Core.FSharpResult`2", [gen0, string_type], FSharpResult$2, () => [[["ResultValue", gen0]], [["ErrorValue", string_type]]]))]]]);
}

export function Validation$1__get_Value(x) {
    if (x.tag === 1) {
        return x.fields[0];
    }
    else {
        let clo;
        throw (new Error("Cannot get function of NoValidation type."));
        return clo;
    }
}

export class TextInput$1 extends Record {
    constructor(Type, ValueProp, Disabled, LabelText, Id, Validation, OnBlur, IsBlurred, DynamicWidth, HTMLProps) {
        super();
        this.Type = Type;
        this.ValueProp = ValueProp;
        this.Disabled = Disabled;
        this.LabelText = LabelText;
        this.Id = Id;
        this.Validation = Validation;
        this.OnBlur = OnBlur;
        this.IsBlurred = IsBlurred;
        this.DynamicWidth = DynamicWidth;
        this.HTMLProps = HTMLProps;
    }
}

export function TextInput$1$reflection(gen0) {
    return record_type("Components.FormFields.TextInput`1", [gen0], TextInput$1, () => [["Type", string_type], ["ValueProp", ValueProp$reflection()], ["Disabled", bool_type], ["LabelText", string_type], ["Id", string_type], ["Validation", Validation$1$reflection(gen0)], ["OnBlur", lambda_type(class_type("Browser.Types.FocusEvent", void 0, FocusEvent), unit_type)], ["IsBlurred", bool_type], ["DynamicWidth", bool_type], ["HTMLProps", list_type(class_type("Fable.React.Props.IHTMLProp"))]]);
}

export function TextInput$1_GetDefault() {
    return new TextInput$1("text", new ValueProp(2), false, "", "", new Validation$1(0), (value) => {
    }, false, false, empty());
}

export class IsValid extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Unvalidated", "Valid", "Invalid"];
    }
}

export function IsValid$reflection() {
    return union_type("Components.FormFields.IsValid", [], IsValid, () => [[], [], [["Item", string_type]]]);
}

export function inputText(values) {
    let isValid_1, inputClasses, commonInputFields, getEmWidth, matchValue_1, defaultValue, props_2, realValue, props_4;
    let isValid;
    const matchValue = [values.ValueProp, values.Validation, values.IsBlurred];
    let pattern_matching_result, validationFunc, value;
    if (matchValue[0].tag === 0) {
        if (matchValue[1].tag === 1) {
            if (matchValue[2]) {
                pattern_matching_result = 1;
                validationFunc = matchValue[1].fields[0];
                value = matchValue[0].fields[0];
            }
            else {
                pattern_matching_result = 0;
            }
        }
        else {
            pattern_matching_result = 0;
        }
    }
    else if (matchValue[0].tag === 1) {
        if (matchValue[1].tag === 1) {
            if (matchValue[2]) {
                pattern_matching_result = 1;
                validationFunc = matchValue[1].fields[0];
                value = matchValue[0].fields[0];
            }
            else {
                pattern_matching_result = 0;
            }
        }
        else {
            pattern_matching_result = 0;
        }
    }
    else {
        pattern_matching_result = 0;
    }
    switch (pattern_matching_result) {
        case 0: {
            isValid = (new IsValid(0));
            break;
        }
        case 1: {
            const _arg = validationFunc(value);
            isValid = ((_arg.tag === 1) ? (new IsValid(2, _arg.fields[0])) : (new IsValid(1)));
            break;
        }
    }
    const errorMessageHtml = (isValid.tag === 0) ? react.createElement(react.Fragment, {}) : ((isValid.tag === 2) ? react.createElement("div", {
        className: "input__validation-error",
    }, isValid.fields[0]) : react.createElement(react.Fragment, {}));
    const labelHtml = (values.LabelText === "") ? react.createElement(react.Fragment, {}) : react.createElement("span", {
        className: "input__text-label",
    }, values.LabelText);
    const containerClasses = classNames(ofArray([["input-container", true], ["input-container--disabled", values.Disabled]]));
    const children_6 = [(isValid_1 = isValid, (inputClasses = classNames(ofArray([["input__text", true], ["input__text--valid", equals(isValid_1, new IsValid(1))], ["input__text--invalid", isValid_1.tag === 2]])), (commonInputFields = append(toList(delay(() => append_1((values.Id !== "") ? singleton(new HTMLAttr(99, values.Id)) : empty_1(), delay(() => append_1(singleton(new HTMLAttr(159, values.Type)), delay(() => append_1(singleton(new HTMLAttr(65, inputClasses)), delay(() => append_1(singleton(new HTMLAttr(134, true)), delay(() => append_1(singleton(new HTMLAttr(79, values.Disabled)), delay(() => singleton(new DOMAttr(8, values.OnBlur)))))))))))))), values.HTMLProps), (getEmWidth = ((labelLength, valueLength) => {
        let arg;
        const length = max(comparePrimitives, 10, max(comparePrimitives, labelLength, valueLength));
        arg = (length - (length * 0.1));
        return toText(printf("%frem"))(arg);
    }), (matchValue_1 = values.ValueProp, (matchValue_1.tag === 1) ? ((defaultValue = matchValue_1.fields[0], (props_2 = append(commonInputFields, toList(delay(() => append_1(singleton(new HTMLAttr(1, defaultValue)), delay(() => {
        let css;
        return values.DynamicWidth ? singleton((css = ofArray([new CSSProp(395, getEmWidth(values.LabelText.length, defaultValue.length)), new CSSProp(253, "100%"), new CSSProp(249, "20rem")]), ["style", keyValueList(css, 1)])) : empty_1();
    }))))), react.createElement("input", keyValueList(props_2, 1))))) : ((matchValue_1.tag === 0) ? ((realValue = matchValue_1.fields[0], (props_4 = append(commonInputFields, toList(delay(() => append_1(singleton(new HTMLAttr(161, realValue)), delay(() => append_1(singleton(new DOMAttr(9, (event) => {
        const target = event.target;
        const prevBeginPos = target.selectionStart | 0;
        const prevEndPos = target.selectionEnd | 0;
        matchValue_1.fields[1](event);
        window.requestAnimationFrame((_arg_1) => {
            target.selectionStart = (prevBeginPos | 0);
            target.selectionEnd = (prevEndPos | 0);
        });
    })), delay(() => {
        let css_1;
        return values.DynamicWidth ? singleton((css_1 = ofArray([new CSSProp(395, getEmWidth(values.LabelText.length, realValue.length)), new CSSProp(253, "100%"), new CSSProp(249, "20rem")]), ["style", keyValueList(css_1, 1)])) : empty_1();
    }))))))), react.createElement("input", keyValueList(props_4, 1))))) : react.createElement("input", keyValueList(commonInputFields, 1)))))))), labelHtml, errorMessageHtml];
    return react.createElement("div", {
        className: containerClasses,
    }, ...children_6);
}

export class CheckboxInput extends Record {
    constructor(Disabled, LabelText, OnChange, Value, Id, HTMLProps) {
        super();
        this.Disabled = Disabled;
        this.LabelText = LabelText;
        this.OnChange = OnChange;
        this.Value = Value;
        this.Id = Id;
        this.HTMLProps = HTMLProps;
    }
}

export function CheckboxInput$reflection() {
    return record_type("Components.FormFields.CheckboxInput", [], CheckboxInput, () => [["Disabled", bool_type], ["LabelText", string_type], ["OnChange", lambda_type(class_type("Browser.Types.Event", void 0, Event), unit_type)], ["Value", bool_type], ["Id", string_type], ["HTMLProps", list_type(class_type("Fable.React.Props.IHTMLProp"))]]);
}

export function CheckboxInput_get_getDefault() {
    return new CheckboxInput(false, "", (e) => {
        console.log(some("OnChange default event fired, please override me."), e);
    }, false, "", empty());
}

export function inputCheckbox(values) {
    let children_2, props, props_2;
    const children_4 = [(children_2 = [(props = append(toList(delay(() => append_1((values.Id !== "") ? singleton(new HTMLAttr(99, values.Id)) : empty_1(), delay(() => append_1(singleton(new HTMLAttr(159, "checkbox")), delay(() => append_1(singleton(new HTMLAttr(65, "custom-control-input")), delay(() => append_1(singleton(new DOMAttr(9, values.OnChange)), delay(() => singleton(new HTMLAttr(62, values.Value)))))))))))), values.HTMLProps), react.createElement("input", keyValueList(props, 1))), (props_2 = toList(delay(() => append_1(singleton(new HTMLAttr(65, "custom-control-label")), delay(() => ((values.Id !== "") ? singleton(new HTMLAttr(96, values.Id)) : empty_1()))))), react.createElement("label", keyValueList(props_2, 1), values.LabelText))], react.createElement("div", {
        className: "custom-control custom-checkbox",
    }, ...children_2))];
    return react.createElement("div", {
        className: "input-container input-container--checkbox",
    }, ...children_4);
}


export class DateOptions extends Record {
    constructor(FlatpickrOptions, LabelText, ShowIcon, Disabled, OnClearClick) {
        super();
        this.FlatpickrOptions = FlatpickrOptions;
        this.LabelText = LabelText;
        this.ShowIcon = ShowIcon;
        this.Disabled = Disabled;
        this.OnClearClick = OnClearClick;
    }
}

export function DateOptions$reflection() {
    return record_type("Components.FormFields.DateOptions", [], DateOptions, () => [["FlatpickrOptions", list_type(class_type("Flatpickr.IFlatpickrOption"))], ["LabelText", string_type], ["ShowIcon", bool_type], ["Disabled", bool_type], ["OnClearClick", option_type(lambda_type(class_type("Browser.Types.Event", void 0, Event), unit_type))]]);
}

export function DateOptions_get_getDefault() {
    return new DateOptions(empty(), "", false, false, void 0);
}

export function inputDate(options) {
    let children_6;
    const inputContainerClasses = classNames(ofArray([["input-container", true], ["input-container--disabled", options.Disabled]]));
    const flatpickrClasses = classNames(ofArray([["input__date", true], ["input__date--with-icon", options.ShowIcon]]));
    const augmentedOptions = ofArrayWithTail([options.Disabled ? Disabled_1(true) : Disabled_1(false), ClassName(flatpickrClasses)], options.FlatpickrOptions);
    const labelHtml = (options.LabelText !== "") ? react.createElement("span", {
        className: "input__date-label",
    }, options.LabelText) : react.createElement(react.Fragment, {});
    let clearIconHtml;
    const matchValue = options.OnClearClick;
    if (matchValue != null) {
        const onClick = matchValue;
        const children_4 = [getWrappedMaterialIcon("close")];
        clearIconHtml = react.createElement("div", {
            className: "input__cross-icon",
            onClick: (arg) => {
                onClick(arg);
            },
        }, ...children_4);
    }
    else {
        clearIconHtml = react.createElement(react.Fragment, {});
    }
    const children_9 = [options.ShowIcon ? ((children_6 = [getWrappedMaterialIcon("date_range")], react.createElement("div", {
        className: "input__date-icon",
    }, ...children_6))) : react.createElement(react.Fragment, {}), flatpickr(augmentedOptions), clearIconHtml, labelHtml];
    return react.createElement("div", {
        className: inputContainerClasses,
    }, ...children_9);
}

export class DateOptionsSimple extends Record {
    constructor(Id, Value, OnChange, FormatDateBy, TimeTwentyFour, LabelText, ShowIcon, Disabled, Locale, EnableBy, OnClearClick, ExtraFlatpickrOptions) {
        super();
        this.Id = Id;
        this.Value = Value;
        this.OnChange = OnChange;
        this.FormatDateBy = FormatDateBy;
        this.TimeTwentyFour = TimeTwentyFour;
        this.LabelText = LabelText;
        this.ShowIcon = ShowIcon;
        this.Disabled = Disabled;
        this.Locale = Locale;
        this.EnableBy = EnableBy;
        this.OnClearClick = OnClearClick;
        this.ExtraFlatpickrOptions = ExtraFlatpickrOptions;
    }
}

export function DateOptionsSimple$reflection() {
    return record_type("Components.FormFields.DateOptionsSimple", [], DateOptionsSimple, () => [["Id", string_type], ["Value", option_type(class_type("System.DateTime"))], ["OnChange", option_type(lambda_type(class_type("System.DateTime"), unit_type))], ["FormatDateBy", option_type(lambda_type(class_type("System.DateTime"), string_type))], ["TimeTwentyFour", bool_type], ["LabelText", string_type], ["ShowIcon", bool_type], ["Disabled", bool_type], ["Locale", Locale$reflection()], ["EnableBy", option_type(lambda_type(class_type("System.DateTime"), bool_type))], ["OnClearClick", option_type(lambda_type(class_type("Browser.Types.Event", void 0, Event), unit_type))], ["ExtraFlatpickrOptions", list_type(class_type("Flatpickr.IFlatpickrOption"))]]);
}

export function DateOptionsSimple_get_getDefault() {
    return new DateOptionsSimple("", void 0, void 0, void 0, true, "", false, false, Locale_get_defaultLocale(), void 0, void 0, empty());
}

export function inputDateSimple(options) {
    return inputDate(new DateOptions(append(toList(delay(() => append_1(singleton(Id_1(options.Id)), delay(() => append_1((options.FormatDateBy != null) ? singleton(FormatDateBy_1(value_3(options.FormatDateBy))) : empty_1(), delay(() => append_1(singleton(Locale(options.Locale.FlatpickrLocale)), delay(() => append_1((options.EnableBy != null) ? singleton(EnableBy_1(value_3(options.EnableBy))) : empty_1(), delay(() => append_1((options.OnChange != null) ? singleton(OnChange_1(value_3(options.OnChange))) : empty_1(), delay(() => append_1(singleton(TimeTwentyFour_1(options.TimeTwentyFour)), delay(() => ((options.Value != null) ? singleton(Value_1(value_3(options.Value))) : empty_1()))))))))))))))), options.ExtraFlatpickrOptions), options.LabelText, options.ShowIcon, options.Disabled, void 0));
}

export class SelectOption extends Record {
    constructor(ValueProp, Id, OptionValues, Classes, LabelText, Disabled, HTMLProps) {
        super();
        this.ValueProp = ValueProp;
        this.Id = Id;
        this.OptionValues = OptionValues;
        this.Classes = Classes;
        this.LabelText = LabelText;
        this.Disabled = Disabled;
        this.HTMLProps = HTMLProps;
    }
}

export function SelectOption$reflection() {
    return record_type("Components.FormFields.SelectOption", [], SelectOption, () => [["ValueProp", ValueProp$reflection()], ["Id", string_type], ["OptionValues", list_type(tuple_type(string_type, string_type))], ["Classes", list_type(string_type)], ["LabelText", string_type], ["Disabled", bool_type], ["HTMLProps", list_type(class_type("Fable.React.Props.IHTMLProp"))]]);
}

export function SelectOption_get_getDefault() {
    return new SelectOption(new ValueProp(2), "", empty(), empty(), "", false, empty());
}

export function selectOption(values) {
    let selectHtml;
    const matchValue = values.ValueProp;
    switch (matchValue.tag) {
        case 1: {
            const props_5 = append(toList(delay(() => append_1((values.Id !== "") ? singleton(new HTMLAttr(99, values.Id)) : empty_1(), delay(() => append_1(singleton(new HTMLAttr(1, matchValue.fields[0])), delay(() => append_1(singleton(new HTMLAttr(65, stackClasses(cons("input__select", values.Classes)))), delay(() => singleton(new HTMLAttr(79, values.Disabled)))))))))), values.HTMLProps);
            selectHtml = ((children_5) => react.createElement("select", keyValueList(props_5, 1), ...children_5));
            break;
        }
        case 0: {
            const props_8 = append(toList(delay(() => append_1((values.Id !== "") ? singleton(new HTMLAttr(99, values.Id)) : empty_1(), delay(() => append_1(singleton(new HTMLAttr(161, matchValue.fields[0])), delay(() => append_1(singleton(new DOMAttr(9, matchValue.fields[1])), delay(() => append_1(singleton(new HTMLAttr(65, stackClasses(cons("input__select", values.Classes)))), delay(() => singleton(new HTMLAttr(79, values.Disabled)))))))))))), values.HTMLProps);
            selectHtml = ((children_8) => react.createElement("select", keyValueList(props_8, 1), ...children_8));
            break;
        }
        default: {
            const props_2 = append(toList(delay(() => append_1((values.Id !== "") ? singleton(new HTMLAttr(99, values.Id)) : empty_1(), delay(() => append_1(singleton(new HTMLAttr(65, stackClasses(cons("input__select", values.Classes)))), delay(() => singleton(new HTMLAttr(79, values.Disabled)))))))), values.HTMLProps);
            selectHtml = ((children_2) => react.createElement("select", keyValueList(props_2, 1), ...children_2));
        }
    }
    const inputClasses = classNames(ofArray([["input-container", true], ["input-container--disabled", values.Disabled]]));
    const children_13 = [selectHtml(map((tupledArg) => {
        const props = toList(delay(() => append_1(singleton(new HTMLAttr(161, tupledArg[0])), delay(() => singleton(new HTMLAttr(65, "input__option"))))));
        return react.createElement("option", keyValueList(props, 1), tupledArg[1]);
    }, values.OptionValues)), react.createElement("span", {
        className: "input__select-label",
    }, values.LabelText)];
    return react.createElement("div", {
        className: inputClasses,
    }, ...children_13);
}

export class RadioInput extends Record {
    constructor(Id, Name, OnChange, RadioValue, DisplayString, IsChecked, Disabled) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.OnChange = OnChange;
        this.RadioValue = RadioValue;
        this.DisplayString = DisplayString;
        this.IsChecked = IsChecked;
        this.Disabled = Disabled;
    }
}

export function RadioInput$reflection() {
    return record_type("Components.FormFields.RadioInput", [], RadioInput, () => [["Id", string_type], ["Name", string_type], ["OnChange", lambda_type(class_type("Browser.Types.Event", void 0, Event), unit_type)], ["RadioValue", string_type], ["DisplayString", string_type], ["IsChecked", bool_type], ["Disabled", bool_type]]);
}

export function RadioInput_get_getDefault() {
    return new RadioInput("", "", (e) => {
        let arg;
        logi((arg = Browser_Types_Event__Event_get_Value(e), toText(printf("Radio changed with Value: %s, please override OnChange."))(arg)));
    }, "", "", false, false);
}

export function inputRadio(values) {
    let props;
    const labelClasses = classNames(ofArray([["input__radio-label", true], ["input__radio-label--disabled", values.Disabled]]));
    const children_2 = [(props = toList(delay(() => append_1((values.Id !== "") ? singleton(new HTMLAttr(99, values.Id)) : empty_1(), delay(() => append_1(singleton(new HTMLAttr(159, "radio")), delay(() => append_1(singleton(new HTMLAttr(65, "")), delay(() => append_1(singleton(new HTMLAttr(123, values.Name)), delay(() => append_1(singleton(new HTMLAttr(161, values.RadioValue)), delay(() => append_1(singleton(new HTMLAttr(62, values.IsChecked)), delay(() => append_1(singleton(new HTMLAttr(79, values.Disabled)), delay(() => singleton(new DOMAttr(9, values.OnChange)))))))))))))))))), react.createElement("input", keyValueList(props, 1))), react.createElement("label", {
        htmlFor: values.Id,
        className: labelClasses,
    }, values.DisplayString)];
    return react.createElement("div", {
        className: "input-container input-container--radio",
    }, ...children_2);
}

